import { navigateWithAttribution } from '../composables/attributionNavigation.js';

export default {
    data() {
        return {
            discountCode: '',
            discountMessages: [],
            discountError: '',
            showAlerts: false
        }
    },
    methods: {
        async applyDiscount() {
            this.emitter.emit('isLoading', true);

            var formattedCode = this.discountCode.replace('%', '%25');

            const response = await axios.post('/ajax/apply_discount/' + formattedCode);
        
            if(response.data.discount_applied.discount_applied == true) {
                
                if(!response.data.basket || Object.keys(response.data.basket).length < 1) {
                    void navigateWithAttribution('/error');
                }

                this.emitter.emit('refreshBasket');
            }

            //Clear existing messages
            //Server stores last entry in session.. maybe change later.
            this.discountCode = '';
            this.discountMessages = [];
            this.discountMessages = response.data.discount_applied.messages;
            setTimeout(() => this.discountMessages = [], 2000);

            this.emitter.emit('isLoading', false);
        },
        async clearDiscounts() {
            this.emitter.emit('isLoading', true);

            const response = await axios.post('/ajax/clear_discounts/');

            if(response.data.success) {
                this.emitter.emit('refreshBasket');
            }

            this.emitter.emit('isLoading', false);
        }
    },
    computed: {
        discounts() {
            const basketItems = Object.values(this.basket.basket_discounts)

             return basketItems.filter((basket_item) => {
                return basket_item.type == 'amount_off' || basket_item.type == 'percentage_off';
            });
        },
        promoEntries() {
            const basketItems = Object.values(this.basket.basket_discounts)

             return basketItems.filter((basket_item) => {
                return basket_item.type == 'promo_entry';
            });
        }
    }
};